type LogoProps = {
  color?: '#00995D' | '#fff'
  width?: '31' | '42' | '55'
  height?: '34' | '45' | '61'
}

const LogoSvg = ({
  color = '#00995D',
  width = '42',
  height = '45'
}: LogoProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 47 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.04368 15.7834C5.69594 15.7834 7.78301 17.74 10.3484 21.6098C17.2618 29.8711 21.4359 35.0888 22.9142 37.2193H23.1316C24.3056 36.0453 29.8276 29.2189 39.7412 16.7835C40.2195 16.3487 41.0891 16.0008 42.35 15.7834C44.9154 16.3921 46.2198 17.5661 46.2198 19.2184V20.4358C46.2198 21.262 43.7849 24.523 38.9585 30.1755L28.2188 43.7414C40.2195 58.1769 46.2633 65.7425 46.2633 66.3947V67.6122C46.2633 69.6123 44.9588 70.8297 42.3935 71.2645H42.2196C40.6543 71.2645 38.8716 69.6992 36.9149 66.6121L23.1751 49.7852C12.3485 63.2641 6.696 70.221 6.13075 70.6123C5.47855 71.0037 4.78285 71.2211 4.08717 71.2211H3.91325C1.73922 71.2211 0.478288 69.7862 0.0434832 66.96C0.0434832 65.9164 2.60883 62.438 7.73953 56.6551L18.0444 43.4805L0.391322 21.4359L0 19.7836C0.565247 17.0878 1.91314 15.7834 4.04368 15.7834Z"
        fill={color}
      />
      <path
        d="M31.045 7.78301C31.045 12.0876 27.5666 15.566 23.262 15.566C18.9574 15.566 15.479 12.0876 15.479 7.78301C15.479 3.47844 18.9574 0 23.262 0C27.5666 0 31.045 3.47844 31.045 7.78301Z"
        fill={color}
      />
    </svg>
  )
}

export default LogoSvg
